import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  publishPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/community/public-presentations/`,
  },
  unpublishPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/community/unpublic-presentations/`,
  },
  getAllNotPublishedPresentation: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/list-unpublic`,
  },
  getNewlyAddedPublicPresentations: {
    method: 'GET',
    url: `${configs.baseUrl}/api/community/templates/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const publishPresentation = (params) => {
  return resource.publishPresentation(params)
}

const unpublishPresentation = (params) => {
  return resource.unpublishPresentation(params)
}

const getAllNotPublishedPresentation = async () => {
  const res = await resource.getAllNotPublishedPresentation()
  return res.body
}

const getNewlyAddedPublicPresentations = async () => {
  const res = await resource.getNewlyAddedPublicPresentations()
  return res.body
}

export default {
  initResource,
  publishPresentation,
  unpublishPresentation,
  getAllNotPublishedPresentation,
  getNewlyAddedPublicPresentations,
}
